import { useReopenDealNegotiationMutation } from '@/lib/graphql/generated/graphql';
import { dealRefetchAtom } from '@/states/deal.state';
import { useAtomValue } from 'jotai';

export function useReopenNegotiation(dealId: string) {
  const dealRefetch = useAtomValue(dealRefetchAtom);
  const [reopenDealNegotiationMutation, { loading, error }] =
    useReopenDealNegotiationMutation();

  const reopenNegotiation = async () => {
    const result = await reopenDealNegotiationMutation({
      variables: { dealId },
    });

    const response = result.data?.reopenDealNegotiation;
    if (response?.__typename === 'DomainException') {
      throw new Error(response.code);
    }

    await dealRefetch.fn();
    return result;
  };

  return {
    reopenNegotiation,
    loading,
    error,
  };
}
